export enum ErrorRecovery {
  /**
   * SHOW_ERROR: show an error modal with localised content from Sitecore;
   * the user has two options: the customer can continue in the same funnel session or redirect to the home page;
   * the funnel session and cookies are maintained
   */
  SHOW_ERROR = 'SHOW_ERROR',
  /**
   * EXIT_HOME_PAGE: show an error modal with localised content from Sitecore;
   * the user can only redirect to the home page;
   * the following cookies are deleted: eJRebookingSession, ejSessionExpiry, labi, RBK-XSRF
   */
  EXIT_HOME_PAGE = 'EXIT_HOME_PAGE',
  /**
   * EXIT_HOME_PAGE_AND_LOGOUT: show an error modal, same modal as with EXIT_HOME_PAGE, with localised content from Sitecore;
   * the user can only redirect to the home page;
   * the following cookies are deleted: eJRebookingSession, ejSessionExpiry, labi, RBK-XSRF, PaxEj2Session, eJ2Session
   */
  EXIT_HOME_PAGE_AND_LOGOUT = 'EXIT_HOME_PAGE_AND_LOGOUT',
  /**
   * EXIT_ERROR_PAGE: no error modal; the page content of the user's current page is replaced by
   * the content of an error component (500)
   */
  EXIT_ERROR_PAGE = 'EXIT_ERROR_PAGE',
  /**
   * DO_NOTHING: no error modal
   */
  DO_NOTHING = 'DO_NOTHING'
}

interface OriginalError {
  name: string;
  message: string;
  stack: string;
}

//TODO Update error response body in backend and uncomment below when the values are available-- CDT-533
export interface ErrorResponse {
  code?: number;
  customCode?: string;
  customSystemCode?: string;
  message: string;
  showCorrelation: boolean;
  severity?: string;
  recovery: string;
  category?: string;
  context?: string;
  originalError?: OriginalError;
}

interface ClientSideErrorProps {
  message: string;
  recovery: string;
  showCorrelation: boolean;
}

export class ClientSideError extends Error {
  recovery: string;
  showCorrelation: boolean;
  constructor({ message, recovery, showCorrelation }: ClientSideErrorProps) {
    super(message);
    this.name = 'ClientSideError';
    this.recovery = recovery;
    this.showCorrelation = showCorrelation;
  }
}
